module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nyn-e51b9622dd3101d65c30f727c8f80168.png";